import React from 'react';
import { LoadingSpinnerIcon } from '../icons/TourIcons';
import styles from '../stylesheets/viewSwitchLoadingOverlay.module.scss';

interface ViewSwitchLoadingOverlayProps {
  targetView: 'manager' | 'tenant';
}

const ViewSwitchLoadingOverlay = ({
  targetView,
}: ViewSwitchLoadingOverlayProps) => {
  const title =
    targetView === 'tenant'
      ? 'Switching to tenant view...'
      : 'Switching to property manager view...';

  return (
    <div className={styles.overlay} role="status" aria-live="polite">
      <div className={styles.spinner} aria-hidden="true">
        <LoadingSpinnerIcon />
      </div>
      <h2 className={styles.title}>{title}</h2>
    </div>
  );
};

export default ViewSwitchLoadingOverlay;
